/**
 * 对外 PPT 路由与运营后台模块一一对应；moduleCode 与路由 path 一致（不含前导 /）。
 */
export const PPT_MODULES = {
  robot_map: {
    title: "中关村机器人创新中心·机器人 ",
    designWidth: 2048,
    designHeight: 832
  },
  // xsq_jm: { title: "西三旗·军民1", designWidth: 1920, designHeight: 1080 },
  // xsq_jm2: { title: "西三旗·军民2", designWidth: 1920, designHeight: 1080 },
  sjq_jm: {
    title: "中关村机器人创新中心·融合创新1",
    designWidth: 2048,
    designHeight: 832
  },
  sjq_jm2: {
    title: "中关村机器人创新中心·融合创新2",
    designWidth: 2048,
    designHeight: 832
  },
  ts_rb: {
    title: "唐山机器人创新中心·机器人",
    designWidth: 3096,
    designHeight: 1376
  },
  lae_map: {
    title: "低空经济创新中心·低空经济",
    designWidth: 4024,
    designHeight: 1808
  },
  cq_jm: {
    title: "重庆融合创新·融合创新",
    designWidth: 2176,
    designHeight: 960
  },
  cq_rt: { title: "重庆融合创新·机器人", designWidth: 2176, designHeight: 960 }
  // rt_jm: { title: "融通·军民1", designWidth: 1920, designHeight: 1080 },
  // rt_jm2: { title: "融通·军民2", designWidth: 1920, designHeight: 1080 },
};

export const PPT_MODULE_CODES = Object.keys(PPT_MODULES);

export function isValidModuleCode(code) {
  return Boolean(code && PPT_MODULES[code]);
}
